const generalLocalization = {
  en: {
    ok: 'OK',
    cancel: 'Cancel',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    yes: 'Yes',
    no: 'No',
    enter: 'Enter',
    apply: 'Apply',
    reset: 'Reset',
    exit: 'Exit',
    hours: 'h',
    minutes: 'min',
    seconds: 'сек',
    up: 'Up',
    down: 'Down',
    tryAgain: 'Try again',
    showAll: 'Show all',
    all: 'All',
    today: 'Today',
    yesterday: 'Yesterday',
    menu: 'Menu',
    space: 'Space',
    live: 'Live',
    archive: 'Archive',
    video: 'Video',
    paused: 'Paused',
    download: 'Download',
    mb: 'Mb',
    emptySection: 'Empty...',
    message: 'Message',
    enterParentPass: 'Enter parent password',
    waitingForNetwork: 'Wainting for network..',
    volume: 'Volume',
    brightness: 'Brightness',
    loadMore: 'Load more',
    toDate: 'to',
    company: 'SZAO Interdnestrcom',
  },
  ru: {
    ok: 'Ок',
    cancel: 'Отмена',
    close: 'Закрыть',
    back: 'Назад',
    next: 'Далее',
    yes: 'Да',
    no: 'Нет',
    enter: 'Ввод',
    apply: 'Применить',
    reset: 'Сбросить',
    exit: 'Выход',
    hours: 'ч',
    minutes: 'мин',
    seconds: 'сек',
    up: 'Вверх',
    down: 'Вниз',
    tryAgain: 'Повторить попытку',
    showAll: 'Показать всё',
    all: 'Все',
    today: 'Сегодня',
    yesterday: 'Вчера',
    menu: 'Меню',
    space: 'Пробел',
    live: 'Эфир',
    archive: 'Архив',
    video: 'Видео',
    paused: 'Пауза',
    download: 'Загрузка',
    mb: 'Мб',
    emptySection: 'Пусто...',
    message: 'Сообщение',
    enterParentPass: 'Введите родительский пароль',
    waitingForNetwork: 'Ожидание сети...',
    volume: 'Громкость',
    brightness: 'Яркость',
    loadMore: 'Загрузить ещё',
    toDate: 'до',
    company: 'СЗАО Интерднестрком',
  },
};

export default generalLocalization;
